var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74965 3.37278L1.08691 1.83645L3.29602 1.00244L4.10603 2.28167L1.74965 3.37278Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3184 5.43554C25.5457 5.33521 26.8527 6.09397 26.8527 7.71809H22.2197V7.48607C22.324 6.20057 23.2875 5.51706 24.3184 5.43554Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.164 26.9693C20.164 26.9693 4.33207 27.0383 2.96365 26.9693C1.5891 26.9003 1 25.063 1 25.063L5.21572 25.1006L18.4704 25.2135C18.4704 25.2135 18.4704 26.6683 20.1579 26.963L20.164 26.9693Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3124 5.4292C23.2876 5.51699 22.3242 6.2005 22.2198 7.47973C22.2137 7.55498 22.2076 7.6365 22.2076 7.71174H22.2198V24.9688C22.2198 26.4236 22.0787 26.9691 20.1641 26.9691C18.4705 26.6682 18.4705 25.2133 18.4705 25.2133L5.21582 25.1005V11.2171L5.89083 12.7471L5.9031 12.7597L8.25335 11.6748V11.6623L5.74355 5.97475C6.09333 5.6424 6.59038 5.4292 7.14266 5.4292H24.3124Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3189 5.43554C25.5462 5.33521 26.8533 6.09397 26.8533 7.71809H22.208C22.208 7.63657 22.208 7.56132 22.2203 7.48607C22.3246 6.20057 23.288 5.51706 24.3189 5.43554Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3242 5.4292H7.14227C6.58999 5.4292 6.09294 5.6424 5.74316 5.97475",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.21582 24.969V11.2173",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.106 8.50374L9.42612 14.7345C9.02849 15.4075 9.52527 16.249 10.3205 16.249H17.6803C18.4756 16.249 18.9724 15.4075 18.5747 14.7345L14.8948 8.50374C14.4972 7.83078 13.5036 7.83078 13.106 8.50374Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10.9463V12.7141",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0002,
    cy: 14.4963,
    r: 0.8,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5495 18.999H8.45605",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4453 18.999H17.4271",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3904 21.4639H8.45605",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3789 21.4639H19.3607",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25248 11.6625V11.675L5.90223 12.7599L5.88996 12.7473L5.21495 11.2173L1.75401 3.3726L1.32446 2.40063C1.20787 2.13099 1.32446 1.81745 1.58833 1.69204L2.99357 1.04616C3.25743 0.927011 3.56426 1.04616 3.68698 1.3158L4.6504 3.50428L5.74268 5.97495L8.25248 11.6625Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25259 11.6748L8.11145 14.4966L5.90234 12.7596L8.25259 11.6748Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10443 2.28125L1.74805 3.37236",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61952 3.52295L2.31836 4.5827",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskReport);
export default __webpack_public_path__ + "static/media/riskReport.a6d07bd298db8aca9590050f21a4f087.svg";
export { ForwardRef as ReactComponent };